var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "库存管理", name: "StockManage" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName === "StockManage"
                    ? _c("StockManage")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "商品管理", name: "GoodsManage" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName === "GoodsManage"
                    ? _c("GoodsManage")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "直播管理", name: "LiveManage" } },
            [
              _c(
                "keep-alive",
                [_vm.activeName === "LiveManage" ? _c("LiveManage") : _vm._e()],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "专区会场", name: "AreaManage" } },
            [
              _c(
                "keep-alive",
                [_vm.activeName === "AreaManage" ? _c("AreaManage") : _vm._e()],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "销售订单", name: "OrderManage" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName === "OrderManage"
                    ? _c("OrderManage")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "商城装修", name: "SettingManage" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName === "SettingManage"
                    ? _c("SettingManage")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }